import { render, staticRenderFns } from "./Moveto.vue?vue&type=template&id=20758d9b"
import script from "./Moveto.vue?vue&type=script&lang=js"
export * from "./Moveto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports